// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__d-SO2","content":"styles_content__3wnte"};